import { useCallback } from 'react';
import {
  setContextualSupport as setSupport,
  setCurrentPage,
  setTotalItems,
  setTotalPages,
  unsetContextualSupport as unsetSupport,
} from 'js/actions';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { clearAccessControl, setAccessControl } from 'js/actions/app/accessControlActions';

type AppAdapter = {
  setContextualSupport: (pageKey: string) => void;
  unsetContextualSupport: (pageKey: string) => void;
  setCurrentPage: (page: number) => void;
  setTotalPages: (totalPages: number) => void;
  setTotalItems: (totalItems: number) => void;
  setAccessControl: (mode: string) => void;
  clearAccessControl: () => void;
};

function useAppAdapter(): AppAdapter {
  const dispatch = useAppDispatch();

  const setContextualSupport = useCallback((pageKey) => {
    dispatch(setSupport(pageKey));
  }, []);

  const unsetContextualSupport = useCallback((pageKey) => {
    dispatch(unsetSupport(pageKey));
  }, []);

  const _setCurrentPage = useCallback((page: number) => {
    dispatch(setCurrentPage(page));
  }, []);

  const _setTotalPages = useCallback((totalPages: number) => {
    dispatch(setTotalPages(totalPages));
  }, []);

  const _setTotalItems = useCallback((totalItems: number) => {
    dispatch(setTotalItems(totalItems));
  }, []);

  const _setAccessControl = useCallback((mode: string) => {
    dispatch(setAccessControl(mode));
  }, []);

  const _clearAccessControl = useCallback(() => {
    dispatch(clearAccessControl());
  }, []);

  return {
    setContextualSupport,
    unsetContextualSupport,
    setCurrentPage: _setCurrentPage,
    setTotalPages: _setTotalPages,
    setTotalItems: _setTotalItems,
    setAccessControl: _setAccessControl,
    clearAccessControl: _clearAccessControl,
  };
}

export { useAppAdapter };
